import { render, staticRenderFns } from "./regions-select-modal.vue?vue&type=template&id=6178e9d6&scoped=true&"
import script from "./regions-select-modal.vue?vue&type=script&lang=js&"
export * from "./regions-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./regions-select-modal.vue?vue&type=style&index=0&id=6178e9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6178e9d6",
  null
  
)

export default component.exports